import React, { ForwardedRef, forwardRef } from 'react';

import { Flex } from '@chakra-ui/react';

import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { FeedbackCTA } from '../components/FeedbackCTA';
import { Posts } from '../components/Posts';
import { SectionContainer } from '../components/SectionContainer';

export const Feedback = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => (
  <SectionContainer gap={2} ref={ref}>
    <Flex justifyContent="space-between" alignItems="center" mx={3}>
      <TextBodyMedium bold>Praise / Feedback</TextBodyMedium>
      <FeedbackCTA />
    </Flex>
    <Divider borderColor="#CFD7DF" />
    <Posts />
  </SectionContainer>
));
